import { Box, Button, SxProps, useTheme } from "@mui/material"
import sislogo from '../../assets/SIS_Logo.svg';
import { EnvironmentDescription } from "../shared/EnvironmentDescription";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

export const LoginForm = () => {

    const { instance } = useMsal();
    const theme = useTheme();

    const showEnvironment = globalThis.config.environment !== undefined &&
        globalThis.config.environment.toUpperCase() !== 'PROD';

    const environmentHeight = showEnvironment ? 50 : 0;

    const containerProps: SxProps = { height: `${220 + environmentHeight}px`, width: '400px' };
    const innerContainerProps: SxProps = { position: 'absolute', padding: '40px 20px', ...containerProps }

    const bgcolor1 = "rgb(60, 60, 60)";
    const bgcolor2 = "rgb(10, 10, 10)";

    const handleLogin = () => {
        instance.loginRedirect(loginRequest).catch(e => {
            console.log(e);
        });
    }

    return (
        <Box sx={{ position: 'relative', margin: '100px auto', ...containerProps }}>
            <Box
                sx={{
                    backgroundImage: `linear-gradient(to bottom right, ${bgcolor1}, ${bgcolor2},${bgcolor2}, ${bgcolor1})`,
                    borderRadius: '40px',
                    border: '1px solid rgb(80,80,80)',
                    boxShadow: '2px 2px 6px 4px rgb(80,80,80)',
                    opacity: 0.8,
                    ...innerContainerProps
                }}
            />
            <Box sx={{ ...innerContainerProps }}>
                <Box>
                    <img src={sislogo} alt="sislogo" style={{ height: '40px', paddingRight: '10px' }} />
                </Box>
                <Box sx={{ fontSize: '30px', fontWeight: 'bold' }}>
                    Racing Pricing Manager
                </Box>
                {showEnvironment &&
                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', padding: '20px 0 0 0' }}>
                        <EnvironmentDescription />
                    </Box>
                }
                <Box sx={{ paddingTop: 4, color: theme.palette.grey[400] }}>
                    <span>To access Racing Pricing Manager,</span><br />
                    <span>please login by clicking on the button below.</span>
                </Box>
                <Box sx={{ paddingTop: 4 }}>
                    <Button
                        variant="contained"
                        onClick={handleLogin}
                    >
                        Login
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}
